export default "__VITE_ASSET__DeXFd9r___"